var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('assessment-helper'), _c('activity-stage', [_c('template', {
    slot: "instructions"
  }, [_vm._t("instructions")], 2), _c('article', {
    staticClass: "a-letters-kpm",
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_c('div', {
    staticClass: "letter-wrapper focusable",
    attrs: {
      "tabindex": "0"
    }
  }, [_c('svg', {
    attrs: {
      "height": "134px",
      "width": "134px"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.getKeySvg())
    }
  })])])], 2), _vm._t("keyboard")], 2);
}
var staticRenderFns = []

export { render, staticRenderFns }